const middleware = {}

middleware['admin'] = require('../middleware/admin.js')
middleware['admin'] = middleware['admin'].default || middleware['admin']

middleware['authorities'] = require('../middleware/authorities.js')
middleware['authorities'] = middleware['authorities'].default || middleware['authorities']

middleware['countries'] = require('../middleware/countries.js')
middleware['countries'] = middleware['countries'].default || middleware['countries']

middleware['currencies'] = require('../middleware/currencies.js')
middleware['currencies'] = middleware['currencies'].default || middleware['currencies']

middleware['employees'] = require('../middleware/employees.js')
middleware['employees'] = middleware['employees'].default || middleware['employees']

middleware['features'] = require('../middleware/features.js')
middleware['features'] = middleware['features'].default || middleware['features']

middleware['featureToggle'] = require('../middleware/featureToggle.js')
middleware['featureToggle'] = middleware['featureToggle'].default || middleware['featureToggle']

middleware['feeType'] = require('../middleware/feeType.js')
middleware['feeType'] = middleware['feeType'].default || middleware['feeType']

middleware['integrators'] = require('../middleware/integrators.js')
middleware['integrators'] = middleware['integrators'].default || middleware['integrators']

middleware['internalLinks'] = require('../middleware/internalLinks.js')
middleware['internalLinks'] = middleware['internalLinks'].default || middleware['internalLinks']

middleware['licenses'] = require('../middleware/licenses.js')
middleware['licenses'] = middleware['licenses'].default || middleware['licenses']

middleware['primaryFeeGroups'] = require('../middleware/primaryFeeGroups.js')
middleware['primaryFeeGroups'] = middleware['primaryFeeGroups'].default || middleware['primaryFeeGroups']

middleware['swiftMessageOrderTypes'] = require('../middleware/swiftMessageOrderTypes.js')
middleware['swiftMessageOrderTypes'] = middleware['swiftMessageOrderTypes'].default || middleware['swiftMessageOrderTypes']

middleware['swiftMessageTypes'] = require('../middleware/swiftMessageTypes.js')
middleware['swiftMessageTypes'] = middleware['swiftMessageTypes'].default || middleware['swiftMessageTypes']

export default middleware
